var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChickenSkin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D5E2DA;}\n\t.st1{fill:#F8EEE1;}\n\t.st2{fill:#C06950;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.42,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.12,149.93,60.73,184.22,103.42,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.97,87.14L75.11,71.28c2.52-2.94,2.18-7.36-0.76-9.89c-2.81-2.41-7.01-2.22-9.59,0.44 c-1.62,1.62-2.35,3.94-1.94,6.2c-2.26-0.4-4.57,0.32-6.2,1.94c-2.74,2.75-2.74,7.2,0,9.94c2.57,2.56,6.67,2.73,9.45,0.41 l15.86,15.87L90.97,87.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.38,147.59c4.52-4.52,15.95-23.92,0.12-39.73c-11.02-11.02-19.89-10.39-36.42-14.49 c-6.78-2.26-15.62-10.4-17.87-12.66c-2.26,2.26-1.47,10.52-1.47,10.52s-9.84,0.8-12.1,3.06c2.26,2.26,12.76,12.19,14.59,16.85 c4.94,15.68,4.38,23.65,15.4,34.67C122.71,163.88,137.87,152.11,142.38,147.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenSkin);
export default __webpack_public_path__ + "static/media/Chicken_skin.df91c89ca78cfbafa6080d7c3f947759.svg";
export { ForwardRef as ReactComponent };